import React, { useState, useEffect } from 'react';
import './LimitedOffer.css';
import { Link } from 'react-router-dom'; // Import Link

const LimitedOffer = () => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [currentOfferSlide, setCurrentOfferSlide] = useState(0);
  const [offerAutoPlay, setOfferAutoPlay] = useState(true);
  const [loading, setLoading] = useState(true);

  // Fetch gallery images from API
  useEffect(() => {
    fetch("https://bokundaradentalclinic.com/api/gallery-list.php")
      .then((res) => res.json())
      .then((data) => {
        // Use first 6 images for the slider
        const images = data.images || [];
        setGalleryImages(images.slice(0, 20));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Gallery images load error:", err);
        setLoading(false);
      });
  }, []);

  // Fallback images if API fails
  const fallbackSlides = [
    { id: 1, image: '/images/or_01.jpeg', title: 'Smile Transformation' },
    { id: 2, image: '/images/or_02.jpeg', title: 'Before & After' },
    { id: 3, image: '/images/or_03.jpeg', title: 'Dental Care' },
    { id: 4, image: '/images/or_04.jpeg', title: 'Healthy Smile' },
    { id: 5, image: '/images/or_05.jpeg', title: 'Happy Patients' }
  ];

  const offerSlides = galleryImages.length > 0 ? galleryImages : fallbackSlides;

  // Auto-play slider
  useEffect(() => {
    if (!offerAutoPlay || offerSlides.length === 0) return;
    const interval = setInterval(() => {
      setCurrentOfferSlide((prev) => (prev + 1) % offerSlides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [offerAutoPlay, offerSlides.length]);

  const nextOfferSlide = () => {
    setOfferAutoPlay(false);
    setCurrentOfferSlide((prev) => (prev + 1) % offerSlides.length);
  };

  const prevOfferSlide = () => {
    setOfferAutoPlay(false);
    setCurrentOfferSlide((prev) => (prev - 1 + offerSlides.length) % offerSlides.length);
  };

  const goToOfferSlide = (index) => {
    setOfferAutoPlay(false);
    setCurrentOfferSlide(index);
  };

  if (loading) {
    return (
      <section className="offer-limited-section">
        <div className="offer-container">
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <div style={{ fontSize: '18px', color: '#666' }}>Loading gallery...</div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="offer-limited-section">
      <div className="offer-container">
        <div className="offer-main-wrapper">
          {/* Left Side - Slider */}
          <div className="offer-slider-container">
            <div className="offer-slider-wrapper">
              {offerSlides.map((slide, index) => (
                <div
                  key={slide.id || index}
                  className={`offer-slider-item ${index === currentOfferSlide ? 'offer-active' : ''
                    }`}
                >
                  <img
                    src={slide.url || slide.image || slide.path}
                    alt={slide.title || `Gallery ${index + 1}`}
                    className="offer-slider-image"
                  />
                  <p className="offer-slide-title">
                    {slide.title || `Transformation ${index + 1}`}
                  </p>
                </div>
              ))}
            </div>

            {/* Navigation Arrows */}
            <button
              className="offer-slider-btn offer-prev-btn"
              onClick={prevOfferSlide}
              aria-label="Previous slide"
            >
              ❮
            </button>
            <button
              className="offer-slider-btn offer-next-btn"
              onClick={nextOfferSlide}
              aria-label="Next slide"
            >
              ❯
            </button>

            {/* Dots Indicator */}
            <div className="offer-slider-dots">
              {offerSlides.map((_, index) => (
                <button
                  key={index}
                  className={`offer-dot ${index === currentOfferSlide ? 'offer-dot-active' : ''}`}
                  onClick={() => goToOfferSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>

            {/* Thumbnail Grid */}
            <div className="offer-thumbnail-grid">
              {offerSlides.map((slide, index) => (
                <div
                  key={slide.id || index}
                  className={`offer-thumbnail ${index === currentOfferSlide ? 'offer-thumbnail-active' : ''
                    }`}
                  onClick={() => goToOfferSlide(index)}
                >
                  <img
                    src={slide.url || slide.image || slide.path}
                    alt={`Thumbnail ${index + 1}`}
                    className="offer-thumbnail-image"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Right Side - Offer Text */}
          <div className="offer-content-section">
            <h2 className="offer-content-title">Explore More of Our Work!</h2>
            <p className="offer-content-description">
              For more photos and videos of our work, please visit our social media pages on TikTok, Facebook, Instagram, and Google. We regularly share our latest projects, behind-the-scenes moments, and customer highlights there—don't forget to follow us for updates and new work showcases.
            </p>
            <Link to="/gallery" className="offer-claim-btn" style={{ display: 'inline-block', textDecoration: 'none', textAlign: 'center' }}>
              View Gallery
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LimitedOffer;
